import { SubcategoryEntity } from '@resident-select/domain/subcategory';
import { createEntityEvent } from '../../../shared/base';
import { createAction, props } from '@ngrx/store';

export const CreatedSubcategoryEvent = createEntityEvent<SubcategoryEntity>('CreatedSubcategoryEvent');
export const GotAllSubcategoriesEvent = createAction('GotAllSubcategoriesEvent', props<{ entities: SubcategoryEntity[] }>());
export const UpdatedSubcategoryEvent = createEntityEvent<SubcategoryEntity>('UpdatedSubcategoryEvent');
export const UpdatedStateSubcategoryEvent = createEntityEvent<SubcategoryEntity>('UpdatedStateSubcategoryEvent');